import { Dropdown, Menu } from 'antd';
import React from 'react';
import { SelectOptions } from '../../../model/CommonModel';
import styles from './contextMenu.module.scss';

const { Item } = Menu;

export type ContextMenuProps<T> = {
	options?: SelectOptions<T>[];
	onClickOption?: (value: T) => void;
	children?: JSX.Element;
};

export const ContextMenu: React.FC<ContextMenuProps<number>> = <T extends {}>({ options, onClickOption, children }: ContextMenuProps<T>) => {
	const createMenuItems = (options: SelectOptions<T>[]) => {
		const menuItems: JSX.Element[] = [];

		options.forEach(({ label, disabled, title, icon, id, separator, value }, index) => {
			menuItems.push(
				<Item
					id={id}
					key={`${label}-${index}`}
					onClick={e => {
						e.domEvent.stopPropagation();
						onClickOption?.(value);
					}}
					className={separator ? styles.separator : undefined}
					disabled={disabled}
					title={title}
					icon={icon}>
					{label}
				</Item>
			);
		});

		return menuItems;
	};

	const menu: JSX.Element = <Menu getPopupContainer={(element: HTMLElement) => element.parentElement}>{createMenuItems(options)}</Menu>;

	return (
		<Dropdown overlay={menu} trigger={['contextMenu']}>
			{children}
		</Dropdown>
	);
};
